import React, {useState, memo, useCallback} from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {connect} from 'react-redux';
import {AttachedFile, CloseIcon} from '../SvgComponents/SvgComponents';
import './ContactForm.less';
import {getUserNameFromString} from '../../services/common';

function ContactForm({
  user, options, title, text, onSubmit, inline, onClose, iconType, loggedIn,
}) {
  const [selectOption, changeSelectOption] = useState(options[0]);
  const [topicValue, changeTopicValue] = useState('');
  const [textAreaValue, changeTextAreaValue] = useState('');
  const [attachedFile, changeAttachedFile] = useState(null);
  const [attachedFileName, changeAttachedFileName] = useState('');
  const [name, changeName] = useState(getUserNameFromString(user.name, true));
  const [phoneNumber, changePhoneNumber] = useState(user.phoneNumber || '');
  const [email, changeEmail] = useState(user.username || '');

  const onChangePhoneNumber = useCallback((data = {}) => {
    changePhoneNumber(data.value || '');
  }, []);

  const clearFormFields = useCallback(() => {
    changeName(getUserNameFromString(user.name, true));
    changePhoneNumber(user.phoneNumber || '');
    changeEmail(user.username || '');
    changeAttachedFileName('');
    changeTextAreaValue('');
    changeTopicValue('');
  }, []);

  const submitForm = () => {
    const userId = loggedIn ? user._id : null;
    const userEmail = email || user.username;
    const userPhoneNumber = phoneNumber || user.phoneNumber;
    const req = {
      type: topicValue ? 4 : selectOption.value,
      topic: selectOption.value === 4 ? topicValue : selectOption.label,
      message: textAreaValue,
      user: userId,
      contactEmail: userEmail,
      contactPhone: userPhoneNumber,
      name,
    };

    if (attachedFile) {
      const formData = new FormData();
      formData.append('attachedFile', attachedFile);
      formData.append('message', textAreaValue);
      formData.append('type', req.type);
      formData.append('topic', req.topic);
      if (userId) formData.append('user', userId);
      if (userEmail) formData.append('contactEmail', userEmail);
      if (userPhoneNumber) formData.append('contactPhone', userPhoneNumber);
      if (name) formData.append('name', name);
      onSubmit(formData, true, clearFormFields);
    } else {
      onSubmit(req, false, clearFormFields);
    }
  };

  const downloadFileChangeHandle = useCallback((e) => {
    const file = e.target.files[0];

    if (file) {
      changeAttachedFile(file);
      changeAttachedFileName(file.name);
    }
  }, []);

  return (
    <div className={`panel contact-form ${inline ? 'inline' : ''}`}>
      <div className="contact-form__header">
        <div className="row">
          <div className="col-md-8">
            <h3>{title}</h3>
            {text && <div className="contact-form__text" dangerouslySetInnerHTML={{__html: text}} />}
          </div>
          <div className="col-md-4">
            <div className="contact-form__icon-wrap">
              <div className={`contact-form__icon ${iconType}`} />
            </div>
          </div>
        </div>
      </div>
      <div className="contact-form__field">
        <div className="row">
          <div className="col-sm-4">
            <div className="contact-form__field-item">
              <div className="contact-form__descr-text text-sm">ФИО</div>
              <input
                type="text"
                onChange={(e) => changeName(e.target.value)}
                value={name}
                placeholder="Введите ФИО"
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="contact-form__field-item">
              <div className="contact-form__descr-text text-sm">Номер телефона</div>
              <NumberFormat
                format="+# (###) ###-##-########"
                mask=""
                value={`+ ${phoneNumber}`}
                placeholder="+7 (XXX) XXX-XX-XX"
                onValueChange={onChangePhoneNumber}
                // className={`ui-input ${hasError('phoneNumber') ? 'error' : ''}`}
              />
            </div>
          </div>
          <div className="col-sm-4">
            <div className="contact-form__field-item">
              <div className="contact-form__descr-text text-sm">Электронная почта</div>
              <input
                type="text"
                onChange={(e) => changeEmail(e.target.value)}
                value={email}
                placeholder="Введите email"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="contact-form__field">
        <div className="row">
          <div className="col-sm-6">
            <div className="contact-form__field-item">
              <div className="contact-form__descr-text text-sm">Выберите тему из списка</div>
              <Select
                options={options}
                onChange={(data) => changeSelectOption(data)}
                isSearchable={false}
                classNamePrefix="common-select"
                value={selectOption}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="contact-form__field-item">
              <div className="contact-form__descr-text text-sm">Введите свою тему</div>
              <input
                type="text"
                onChange={(e) => changeTopicValue(e.target.value)}
                value={topicValue}
                placeholder="Введите свою тему"
                disabled={selectOption.value !== 4}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="contact-form__message">
        <textarea
          placeholder="Опишите Вашу проблему или предложение (количество символов не менее 10)"
          onChange={(e) => changeTextAreaValue(e.target.value)}
          value={textAreaValue}
        />
      </div>
      <div className="contact-form__footer">
        <div className="row">
          <div className="col-sm-5">
            <div className="file-wrap">
              <label htmlFor="attach-file" className="label-file">
                <AttachedFile />
                {attachedFileName && attachedFile ? attachedFileName : 'Прикрепить файл'}
                <input type="file" id="attach-file" className="attach-file" onChange={downloadFileChangeHandle} />
              </label>
            </div>
          </div>
          <div className="col-sm-7">
            <div className="button-wrap">
              <button
                type="button"
                className="btn btn-base margin-none"
                onClick={submitForm}
                disabled={textAreaValue.length < 10}
              >
                Отправить
              </button>
            </div>
          </div>
        </div>
      </div>
      {!inline && (
        <button type="button" className="close-btn" onClick={onClose}>
          <CloseIcon />
        </button>
      )}
    </div>
  );
}

ContactForm.defaultProps = {
  options: [{label: '', value: ''}],
  inline: false,
  text: '',
  onClose: () => {},
  user: {},
};

ContactForm.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  inline: PropTypes.bool,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  user: PropTypes.shape({}),
};

function mapStateToProps({rSession, rUser}) {
  return {
    loggedIn: rSession.LOGGED_IN,
    user: rUser,
  };
}

export default connect(mapStateToProps, null)(memo(ContactForm));
